"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _ControlsManager_controls, _ControlsManager_defaultTextures, _ControlsManager_drawingToolsId, _ControlsManager_drawingToolsManager, _ControlsManager_eventListenerTokens, _ControlsManager_eventEngine, _ControlsManager_geometryMathManager, _ControlsManager_geometryNodeId, _ControlsManager_parentNode, _ControlsManager_settings, _ControlsManager_viewport, _ControlsManager_draggedControlIndex, _ControlsManager_dragStartMidpoint, _ControlsManager_geometryData, _ControlsManager_hoveredControlIndex, _ControlsManager_hoveredControlDistance, _ControlsManager_isDraggingControl, _ControlsManager_materialIndexArray, _ControlsManager_positionArray, _ControlsManager_positionIndexArray;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ControlsManager = void 0;
const viewer_1 = require("@shapediver/viewer");
const viewer_shared_services_1 = require("@shapediver/viewer.shared.services");
const viewer_shared_types_1 = require("@shapediver/viewer.shared.types");
const gl_matrix_1 = require("gl-matrix");
const IDrawingToolsManager_1 = require("../../../interfaces/IDrawingToolsManager");
const EdgeControl_1 = require("./EdgeControl");
class ControlsManager {
    constructor(drawingToolsManager) {
        _ControlsManager_controls.set(this, []);
        _ControlsManager_defaultTextures.set(this, void 0);
        _ControlsManager_drawingToolsId.set(this, void 0);
        _ControlsManager_drawingToolsManager.set(this, void 0);
        _ControlsManager_eventListenerTokens.set(this, []);
        _ControlsManager_eventEngine.set(this, viewer_shared_services_1.EventEngine.instance);
        _ControlsManager_geometryMathManager.set(this, void 0);
        _ControlsManager_geometryNodeId.set(this, void 0);
        _ControlsManager_parentNode.set(this, void 0);
        _ControlsManager_settings.set(this, void 0);
        _ControlsManager_viewport.set(this, void 0);
        _ControlsManager_draggedControlIndex.set(this, void 0);
        _ControlsManager_dragStartMidpoint.set(this, void 0);
        _ControlsManager_geometryData.set(this, void 0);
        // Hover state
        _ControlsManager_hoveredControlIndex.set(this, void 0);
        _ControlsManager_hoveredControlDistance.set(this, void 0);
        // Drag state
        _ControlsManager_isDraggingControl.set(this, false);
        _ControlsManager_materialIndexArray.set(this, new Array(1024).fill(0));
        _ControlsManager_positionArray.set(this, void 0);
        _ControlsManager_positionIndexArray.set(this, void 0);
        __classPrivateFieldSet(this, _ControlsManager_drawingToolsManager, drawingToolsManager, "f");
        __classPrivateFieldSet(this, _ControlsManager_drawingToolsId, drawingToolsManager.uuid, "f");
        __classPrivateFieldSet(this, _ControlsManager_geometryNodeId, drawingToolsManager.geometryManager.parentNode.id, "f");
        __classPrivateFieldSet(this, _ControlsManager_geometryMathManager, drawingToolsManager.geometryMathManager, "f");
        __classPrivateFieldSet(this, _ControlsManager_viewport, drawingToolsManager.viewport, "f");
        __classPrivateFieldSet(this, _ControlsManager_settings, drawingToolsManager.settings, "f");
        __classPrivateFieldSet(this, _ControlsManager_defaultTextures, drawingToolsManager.defaultTextures, "f");
        const parentNode = new viewer_1.TreeNode("DrawingToolsControls");
        parentNode.intersectionTest = false;
        drawingToolsManager.parentNode.addChild(parentNode);
        __classPrivateFieldSet(this, _ControlsManager_parentNode, parentNode, "f");
        this.buildControls();
        this.initGeometry();
        this.setupEventListeners();
    }
    get controlCount() {
        return __classPrivateFieldGet(this, _ControlsManager_controls, "f").length;
    }
    get hoveredControlIndex() {
        return __classPrivateFieldGet(this, _ControlsManager_hoveredControlIndex, "f");
    }
    get hoveredControlDistance() {
        return __classPrivateFieldGet(this, _ControlsManager_hoveredControlDistance, "f");
    }
    get isDraggingControl() {
        return __classPrivateFieldGet(this, _ControlsManager_isDraggingControl, "f");
    }
    /**
     * Returns the screen-space distance to the closest control for the given ray
     * without modifying hover state. Returns undefined if no control is within
     * the hit threshold.
     */
    closestControlDistance(ray) {
        var _a;
        if (__classPrivateFieldGet(this, _ControlsManager_controls, "f").length === 0)
            return undefined;
        const distances = __classPrivateFieldGet(this, _ControlsManager_geometryMathManager, "f").checkPointDistances(ray, __classPrivateFieldGet(this, _ControlsManager_positionArray, "f"));
        return (_a = distances === null || distances === void 0 ? void 0 : distances[0]) === null || _a === void 0 ? void 0 : _a.distance;
    }
    /**
     * Checks which control (if any) is closest to the given ray.
     * Updates hover visual state and returns true if a control is hovered.
     */
    checkHover(ray) {
        if (__classPrivateFieldGet(this, _ControlsManager_controls, "f").length === 0)
            return false;
        const distances = __classPrivateFieldGet(this, _ControlsManager_geometryMathManager, "f").checkPointDistances(ray, __classPrivateFieldGet(this, _ControlsManager_positionArray, "f"));
        if (distances) {
            const index = distances[0].index;
            if (__classPrivateFieldGet(this, _ControlsManager_hoveredControlIndex, "f") !== index) {
                if (__classPrivateFieldGet(this, _ControlsManager_hoveredControlIndex, "f") !== undefined) {
                    this.updateMaterialIndex(__classPrivateFieldGet(this, _ControlsManager_hoveredControlIndex, "f"), IDrawingToolsManager_1.MATERIAL_INDEX.DEFAULT);
                }
                __classPrivateFieldSet(this, _ControlsManager_hoveredControlIndex, index, "f");
                this.updateMaterialIndex(index, IDrawingToolsManager_1.MATERIAL_INDEX.HOVERED);
            }
            __classPrivateFieldSet(this, _ControlsManager_hoveredControlDistance, distances[0].distance, "f");
            return true;
        }
        this.clearHover();
        return false;
    }
    clearHover() {
        if (__classPrivateFieldGet(this, _ControlsManager_hoveredControlIndex, "f") !== undefined) {
            this.updateMaterialIndex(__classPrivateFieldGet(this, _ControlsManager_hoveredControlIndex, "f"), IDrawingToolsManager_1.MATERIAL_INDEX.DEFAULT);
            __classPrivateFieldSet(this, _ControlsManager_hoveredControlIndex, undefined, "f");
        }
        __classPrivateFieldSet(this, _ControlsManager_hoveredControlDistance, undefined, "f");
    }
    close() {
        __classPrivateFieldGet(this, _ControlsManager_eventListenerTokens, "f").forEach((token) => (0, viewer_1.removeListener)(token));
        __classPrivateFieldGet(this, _ControlsManager_eventListenerTokens, "f").length = 0;
        const parent = __classPrivateFieldGet(this, _ControlsManager_drawingToolsManager, "f").parentNode;
        parent.removeChild(__classPrivateFieldGet(this, _ControlsManager_parentNode, "f"));
        parent.updateVersion();
    }
    /**
     * Commits the drag.
     *
     * Emits `DRAG_END` first — this allows external commit handlers
     * (e.g. `RectangleTransform.handleRectDrag`) to permanently flush DT
     * point positions before the `GEOMETRY_CHANGED` record is written.
     * Then emits `GEOMETRY_CHANGED` so the HistoryManager captures the
     * final state.  Also delegates end-of-drag state refresh to the control.
     */
    endDragging() {
        if (!__classPrivateFieldGet(this, _ControlsManager_isDraggingControl, "f") || __classPrivateFieldGet(this, _ControlsManager_draggedControlIndex, "f") === undefined)
            return;
        const control = __classPrivateFieldGet(this, _ControlsManager_controls, "f")[__classPrivateFieldGet(this, _ControlsManager_draggedControlIndex, "f")];
        const geometryState = __classPrivateFieldGet(this, _ControlsManager_drawingToolsManager, "f").geometryState;
        // Emit DRAG_END so that commit-phase handlers fire synchronously
        // (e.g. flushRectPoints with temporary=false) before GEOMETRY_CHANGED.
        __classPrivateFieldGet(this, _ControlsManager_eventEngine, "f").emitEvent(viewer_shared_services_1.EVENTTYPE_DRAWING_TOOLS.DRAG_END, {
            viewportId: __classPrivateFieldGet(this, _ControlsManager_viewport, "f").id,
            drawingToolsId: __classPrivateFieldGet(this, _ControlsManager_drawingToolsId, "f"),
            controlIndex: __classPrivateFieldGet(this, _ControlsManager_draggedControlIndex, "f"),
            points: geometryState.getPointsData(),
            metaData: geometryState.metadataArray,
        });
        // positionArray now reflects the committed positions (updated by the
        // DRAG_END handler's non-temporary flushRectPoints, or by in-place
        // mutation from temporary moves if no handler is present).
        __classPrivateFieldGet(this, _ControlsManager_eventEngine, "f").emitEvent(viewer_shared_services_1.EVENTTYPE_DRAWING_TOOLS.GEOMETRY_CHANGED, {
            viewportId: __classPrivateFieldGet(this, _ControlsManager_viewport, "f").id,
            drawingToolsId: __classPrivateFieldGet(this, _ControlsManager_drawingToolsId, "f"),
            points: geometryState.getPointsData(),
            metaData: geometryState.metadataArray,
            temporary: false,
            fromHistory: false,
        });
        // Refresh the control's derived state now that geometry is committed.
        control.end((idx) => geometryState.getPosition(idx));
        this.updateMaterialIndex(__classPrivateFieldGet(this, _ControlsManager_draggedControlIndex, "f"), IDrawingToolsManager_1.MATERIAL_INDEX.HOVERED);
        __classPrivateFieldSet(this, _ControlsManager_isDraggingControl, false, "f");
        __classPrivateFieldSet(this, _ControlsManager_draggedControlIndex, undefined, "f");
        __classPrivateFieldSet(this, _ControlsManager_dragStartMidpoint, undefined, "f");
    }
    /**
     * Delegates the drag-move to the control, then updates the visual position
     * and emits `DRAG_MOVE` so that external listeners (e.g. RectangleTransform)
     * can react on every frame.
     */
    moveDraggedControl(ray) {
        if (!__classPrivateFieldGet(this, _ControlsManager_isDraggingControl, "f") || __classPrivateFieldGet(this, _ControlsManager_draggedControlIndex, "f") === undefined)
            return;
        const control = __classPrivateFieldGet(this, _ControlsManager_controls, "f")[__classPrivateFieldGet(this, _ControlsManager_draggedControlIndex, "f")];
        const geometryState = __classPrivateFieldGet(this, _ControlsManager_drawingToolsManager, "f").geometryState;
        // Query the active restriction so the control's movement is
        // constrained to both the restriction surface and the direction axis.
        const restrictionManager = __classPrivateFieldGet(this, _ControlsManager_drawingToolsManager, "f").restrictionManager;
        restrictionManager.showRestrictionVisualization = true;
        const metaData = {
            type: "drawing",
            startPoint: __classPrivateFieldGet(this, _ControlsManager_dragStartMidpoint, "f")
                ? gl_matrix_1.vec3.clone(__classPrivateFieldGet(this, _ControlsManager_dragStartMidpoint, "f"))
                : gl_matrix_1.vec3.create(),
            positionArray: __classPrivateFieldGet(this, _ControlsManager_drawingToolsManager, "f").positionArray,
        };
        const rayTraceResult = restrictionManager.rayTrace(ray, metaData);
        const restrictedPosition = rayTraceResult === null || rayTraceResult === void 0 ? void 0 : rayTraceResult.point;
        // Track which points were moved and their new temporary positions so
        // sibling controls that share those points can be refreshed below.
        const movedPoints = new Map();
        const newPos = control.move(ray, (idx, pos) => {
            movedPoints.set(idx, gl_matrix_1.vec3.clone(pos));
            __classPrivateFieldGet(this, _ControlsManager_drawingToolsManager, "f").movePointTemporary(idx, pos, rayTraceResult);
        }, restrictedPosition, (pos, idx, overrides, originalPositionOverride) => __classPrivateFieldGet(this, _ControlsManager_drawingToolsManager, "f").applyConstraints(pos, idx, overrides, originalPositionOverride));
        if (newPos === undefined)
            return;
        this.setControlPosition(__classPrivateFieldGet(this, _ControlsManager_draggedControlIndex, "f"), newPos);
        // Refresh every other control whose point1 or point2 was just moved.
        // Temporary moves bypass geometryState.#positionArray, so we supply a
        // custom getPosition that prefers the freshly moved positions.
        if (movedPoints.size > 0) {
            const getPosition = (idx) => { var _a; return (_a = movedPoints.get(idx)) !== null && _a !== void 0 ? _a : geometryState.getPosition(idx); };
            const refreshed = new Set();
            for (const movedIdx of movedPoints.keys()) {
                for (let i = 0; i < __classPrivateFieldGet(this, _ControlsManager_controls, "f").length; i++) {
                    if (i === __classPrivateFieldGet(this, _ControlsManager_draggedControlIndex, "f"))
                        continue;
                    if (refreshed.has(i))
                        continue;
                    if (__classPrivateFieldGet(this, _ControlsManager_controls, "f")[i].refreshForMovedPoint(movedIdx, getPosition)) {
                        this.setControlPosition(i, __classPrivateFieldGet(this, _ControlsManager_controls, "f")[i].position);
                        refreshed.add(i);
                    }
                }
            }
        }
        // Notify listeners (e.g. RectangleTransform) on every drag frame.
        __classPrivateFieldGet(this, _ControlsManager_eventEngine, "f").emitEvent(viewer_shared_services_1.EVENTTYPE_DRAWING_TOOLS.DRAG_MOVE, {
            viewportId: __classPrivateFieldGet(this, _ControlsManager_viewport, "f").id,
            drawingToolsId: __classPrivateFieldGet(this, _ControlsManager_drawingToolsId, "f"),
            controlIndex: __classPrivateFieldGet(this, _ControlsManager_draggedControlIndex, "f"),
            points: geometryState.getPointsData(),
            metaData: geometryState.metadataArray,
        });
    }
    /**
     * Resets hover and drag state to pre-interaction values, delegating point
     * restoration to the control itself.
     */
    onOut() {
        if (__classPrivateFieldGet(this, _ControlsManager_isDraggingControl, "f") &&
            __classPrivateFieldGet(this, _ControlsManager_draggedControlIndex, "f") !== undefined) {
            const control = __classPrivateFieldGet(this, _ControlsManager_controls, "f")[__classPrivateFieldGet(this, _ControlsManager_draggedControlIndex, "f")];
            control.cancel((idx, pos) => __classPrivateFieldGet(this, _ControlsManager_drawingToolsManager, "f").movePointTemporary(idx, pos, undefined));
            this.setControlPosition(__classPrivateFieldGet(this, _ControlsManager_draggedControlIndex, "f"), control.position);
            this.updateMaterialIndex(__classPrivateFieldGet(this, _ControlsManager_draggedControlIndex, "f"), IDrawingToolsManager_1.MATERIAL_INDEX.DEFAULT);
        }
        this.clearHover();
        __classPrivateFieldSet(this, _ControlsManager_isDraggingControl, false, "f");
        __classPrivateFieldSet(this, _ControlsManager_draggedControlIndex, undefined, "f");
        __classPrivateFieldSet(this, _ControlsManager_dragStartMidpoint, undefined, "f");
    }
    /**
     * Begins dragging the currently hovered control.
     * Delegates start-of-drag snapshotting to the control itself.
     * Returns true if dragging started.
     */
    startDragging() {
        if (__classPrivateFieldGet(this, _ControlsManager_hoveredControlIndex, "f") === undefined)
            return false;
        const control = __classPrivateFieldGet(this, _ControlsManager_controls, "f")[__classPrivateFieldGet(this, _ControlsManager_hoveredControlIndex, "f")];
        const geometryState = __classPrivateFieldGet(this, _ControlsManager_drawingToolsManager, "f").geometryState;
        if (!control.start((idx) => geometryState.getPosition(idx)))
            return false;
        __classPrivateFieldSet(this, _ControlsManager_draggedControlIndex, __classPrivateFieldGet(this, _ControlsManager_hoveredControlIndex, "f"), "f");
        __classPrivateFieldSet(this, _ControlsManager_dragStartMidpoint, gl_matrix_1.vec3.clone(control.position), "f");
        __classPrivateFieldSet(this, _ControlsManager_isDraggingControl, true, "f");
        this.updateMaterialIndex(__classPrivateFieldGet(this, _ControlsManager_hoveredControlIndex, "f"), IDrawingToolsManager_1.MATERIAL_INDEX.SELECTED_HOVERED);
        return true;
    }
    buildControls() {
        const controls = __classPrivateFieldGet(this, _ControlsManager_settings, "f").controls;
        if (!controls || controls.length === 0)
            return;
        const geometryState = __classPrivateFieldGet(this, _ControlsManager_drawingToolsManager, "f").geometryState;
        for (const cfg of controls) {
            if (cfg.type === "edge") {
                const edgeCfg = cfg;
                const p1 = geometryState.getPosition(edgeCfg.point1);
                const p2 = geometryState.getPosition(edgeCfg.point2);
                __classPrivateFieldGet(this, _ControlsManager_controls, "f").push(new EdgeControl_1.EdgeControl(edgeCfg, p1, p2));
            }
        }
    }
    initGeometry() {
        var _a, _b, _c, _d;
        const count = __classPrivateFieldGet(this, _ControlsManager_controls, "f").length;
        if (count === 0)
            return;
        // Build flat position buffer from initial midpoints.
        __classPrivateFieldSet(this, _ControlsManager_positionArray, new Float32Array(count * 3), "f");
        for (let i = 0; i < count; i++) {
            __classPrivateFieldGet(this, _ControlsManager_positionArray, "f").set(__classPrivateFieldGet(this, _ControlsManager_controls, "f")[i].position, i * 3);
        }
        // position-index attribute: point i uses materialIndexArray[i].
        __classPrivateFieldSet(this, _ControlsManager_positionIndexArray, new Float32Array(count), "f");
        for (let i = 0; i < count; i++)
            __classPrivateFieldGet(this, _ControlsManager_positionIndexArray, "f")[i] = i;
        __classPrivateFieldSet(this, _ControlsManager_geometryData, new viewer_1.GeometryData(new viewer_1.PrimitiveData({
            POSITION: new viewer_1.AttributeData(__classPrivateFieldGet(this, _ControlsManager_positionArray, "f"), 3, 12, 0, 4, false, __classPrivateFieldGet(this, _ControlsManager_positionArray, "f").length),
        }), viewer_shared_types_1.PRIMITIVE_MODE.POINTS), "f");
        __classPrivateFieldGet(this, _ControlsManager_geometryData, "f").primitive.attributes["POSITION_INDEX"] =
            new viewer_1.AttributeData(__classPrivateFieldGet(this, _ControlsManager_positionIndexArray, "f"), 1, 1, 0, 1, true, __classPrivateFieldGet(this, _ControlsManager_positionIndexArray, "f").length, [0], [__classPrivateFieldGet(this, _ControlsManager_positionIndexArray, "f").length]);
        __classPrivateFieldGet(this, _ControlsManager_geometryData, "f").renderOrder = 1001; // above regular points (1000)
        __classPrivateFieldGet(this, _ControlsManager_geometryData, "f").material = new viewer_1.MaterialMultiPointData(Object.assign({
            materialIndexDataMap: new viewer_1.MapData(new Image(), {
                asData: true,
                data: __classPrivateFieldGet(this, _ControlsManager_materialIndexArray, "f"),
            }),
            materialIndexDataMapSize: 1024,
            alphaMode: viewer_shared_types_1.MATERIAL_ALPHA.BLEND,
            depthTest: false,
            depthWrite: false,
            transparent: true,
        }, (_b = (_a = __classPrivateFieldGet(this, _ControlsManager_settings, "f").visualization.edgeControlVisualization) === null || _a === void 0 ? void 0 : _a.points) !== null && _b !== void 0 ? _b : __classPrivateFieldGet(this, _ControlsManager_settings, "f").visualization.points));
        const applyTexture = (variations, map) => {
            for (const v of variations) {
                __classPrivateFieldGet(this, _ControlsManager_geometryData, "f").material[v] = map;
            }
            __classPrivateFieldGet(this, _ControlsManager_geometryData, "f").material.updateVersion();
            __classPrivateFieldGet(this, _ControlsManager_geometryData, "f").updateVersion();
        };
        const variations = [
            "map_0",
            "map_1",
            "map_2",
            "map_3",
            "map_4",
            "map_5",
            "map_6",
            "map_7",
        ];
        if (__classPrivateFieldGet(this, _ControlsManager_defaultTextures, "f").variation_0 instanceof viewer_1.MapData) {
            applyTexture(variations, __classPrivateFieldGet(this, _ControlsManager_defaultTextures, "f").variation_0);
        }
        else {
            __classPrivateFieldGet(this, _ControlsManager_defaultTextures, "f").variation_0.then((map) => applyTexture(variations, map));
        }
        // Override specific map slots with any URL strings supplied in the settings.
        const pointSettings = ((_d = (_c = __classPrivateFieldGet(this, _ControlsManager_settings, "f").visualization
            .edgeControlVisualization) === null || _c === void 0 ? void 0 : _c.points) !== null && _d !== void 0 ? _d : __classPrivateFieldGet(this, _ControlsManager_settings, "f").visualization.points);
        // if a single "map" property is provided, use it for all variations
        if (pointSettings["map"]) {
            const mapValue = pointSettings["map"];
            if (typeof mapValue === "string") {
                viewer_1.MaterialEngine.instance.loadMap(mapValue).then((map) => {
                    if (map)
                        applyTexture(variations, map);
                });
            }
        }
        // if specific "map_0" to "map_7" properties are provided, use them for the corresponding variations
        for (const key of variations) {
            const settingValue = pointSettings[key];
            if (typeof settingValue === "string") {
                viewer_1.MaterialEngine.instance.loadMap(settingValue).then((map) => {
                    if (map)
                        applyTexture([key], map);
                });
            }
        }
        __classPrivateFieldGet(this, _ControlsManager_parentNode, "f").addData(__classPrivateFieldGet(this, _ControlsManager_geometryData, "f"));
    }
    setControlPosition(controlIndex, pos) {
        var _a, _b;
        const threeJsGeometry = (_b = (_a = __classPrivateFieldGet(this, _ControlsManager_geometryData, "f")) === null || _a === void 0 ? void 0 : _a.convertedObject) === null || _b === void 0 ? void 0 : _b[__classPrivateFieldGet(this, _ControlsManager_viewport, "f").id];
        if (threeJsGeometry) {
            threeJsGeometry.geometry.attributes["position"].setXYZ(controlIndex, pos[0], pos[1], pos[2]);
            threeJsGeometry.geometry.attributes["position"].needsUpdate = true;
        }
        else {
            // Not yet rendered: update the underlying array directly.
            __classPrivateFieldGet(this, _ControlsManager_positionArray, "f").set(pos, controlIndex * 3);
        }
    }
    setupEventListeners() {
        // When a real point is moved (temporary or permanent), refresh any
        // controls that reference it as point1 or point2.
        __classPrivateFieldGet(this, _ControlsManager_eventListenerTokens, "f").push((0, viewer_1.addListener)(viewer_shared_services_1.EVENTTYPE_DRAWING_TOOLS.MOVED, (e) => {
            const event = e;
            if (event.drawingToolsId !== __classPrivateFieldGet(this, _ControlsManager_geometryNodeId, "f"))
                return;
            if (event.index !== undefined) {
                this.updateControlsForPoint(event.index);
            }
        }));
        // Full refresh on any permanent geometry change (e.g. undo/redo).
        __classPrivateFieldGet(this, _ControlsManager_eventListenerTokens, "f").push((0, viewer_1.addListener)(viewer_shared_services_1.EVENTTYPE_DRAWING_TOOLS.GEOMETRY_CHANGED, (e) => {
            const event = e;
            if (event.drawingToolsId !== __classPrivateFieldGet(this, _ControlsManager_drawingToolsId, "f"))
                return;
            if (event.temporary)
                return;
            if (__classPrivateFieldGet(this, _ControlsManager_isDraggingControl, "f"))
                return;
            this.updateAllControls();
        }));
    }
    updateAllControls() {
        const getPosition = (idx) => __classPrivateFieldGet(this, _ControlsManager_drawingToolsManager, "f").geometryState.getPosition(idx);
        for (let i = 0; i < __classPrivateFieldGet(this, _ControlsManager_controls, "f").length; i++) {
            __classPrivateFieldGet(this, _ControlsManager_controls, "f")[i].refreshAll(getPosition);
            this.setControlPosition(i, __classPrivateFieldGet(this, _ControlsManager_controls, "f")[i].position);
        }
    }
    updateControlsForPoint(movedIndex) {
        // During a drag, geometryState.positionArray is stale for temporarily-moved
        // points (it is only updated on permanent moves). Read live positions from
        // the THREE.js buffer, which IS updated for temporary moves.
        const getPosition = __classPrivateFieldGet(this, _ControlsManager_isDraggingControl, "f")
            ? (idx) => this.getLivePosition(idx)
            : (idx) => __classPrivateFieldGet(this, _ControlsManager_drawingToolsManager, "f").geometryState.getPosition(idx);
        for (let i = 0; i < __classPrivateFieldGet(this, _ControlsManager_controls, "f").length; i++) {
            if (__classPrivateFieldGet(this, _ControlsManager_controls, "f")[i].refreshForMovedPoint(movedIndex, getPosition)) {
                this.setControlPosition(i, __classPrivateFieldGet(this, _ControlsManager_controls, "f")[i].position);
            }
        }
    }
    /**
     * Returns the current live position of a geometry point, reading from the
     * THREE.js buffer so that temporary (uncommitted) moves are reflected.
     */
    getLivePosition(index) {
        var _a;
        const geom = (_a = __classPrivateFieldGet(this, _ControlsManager_drawingToolsManager, "f").geometryState.geometryDataPoints
            .convertedObject) === null || _a === void 0 ? void 0 : _a[__classPrivateFieldGet(this, _ControlsManager_viewport, "f").id];
        if (geom) {
            const attr = geom.geometry.attributes["position"];
            return gl_matrix_1.vec3.fromValues(attr.getX(index), attr.getY(index), attr.getZ(index));
        }
        return __classPrivateFieldGet(this, _ControlsManager_drawingToolsManager, "f").geometryState.getPosition(index);
    }
    updateMaterialIndex(controlIndex, materialIndex) {
        var _a;
        if (!__classPrivateFieldGet(this, _ControlsManager_geometryData, "f"))
            return;
        __classPrivateFieldGet(this, _ControlsManager_materialIndexArray, "f")[controlIndex] = materialIndex;
        const threeJsGeometry = (_a = __classPrivateFieldGet(this, _ControlsManager_geometryData, "f").convertedObject) === null || _a === void 0 ? void 0 : _a[__classPrivateFieldGet(this, _ControlsManager_viewport, "f").id];
        if (threeJsGeometry) {
            const mat = threeJsGeometry.material;
            const materialIndexDataTexture = mat.materialIndexDataTexture;
            const materialIndexData = materialIndexDataTexture === null || materialIndexDataTexture === void 0 ? void 0 : materialIndexDataTexture.image.data;
            if (materialIndexDataTexture && materialIndexData) {
                materialIndexData[controlIndex] = materialIndex;
                materialIndexDataTexture.needsUpdate = true;
                mat.needsUpdate = true;
            }
        }
        __classPrivateFieldGet(this, _ControlsManager_geometryData, "f").material.materialIndexDataMap = new viewer_1.MapData(new Image(), {
            asData: true,
            data: __classPrivateFieldGet(this, _ControlsManager_materialIndexArray, "f"),
        });
        __classPrivateFieldGet(this, _ControlsManager_geometryData, "f").material.updateVersion();
    }
}
exports.ControlsManager = ControlsManager;
_ControlsManager_controls = new WeakMap(), _ControlsManager_defaultTextures = new WeakMap(), _ControlsManager_drawingToolsId = new WeakMap(), _ControlsManager_drawingToolsManager = new WeakMap(), _ControlsManager_eventListenerTokens = new WeakMap(), _ControlsManager_eventEngine = new WeakMap(), _ControlsManager_geometryMathManager = new WeakMap(), _ControlsManager_geometryNodeId = new WeakMap(), _ControlsManager_parentNode = new WeakMap(), _ControlsManager_settings = new WeakMap(), _ControlsManager_viewport = new WeakMap(), _ControlsManager_draggedControlIndex = new WeakMap(), _ControlsManager_dragStartMidpoint = new WeakMap(), _ControlsManager_geometryData = new WeakMap(), _ControlsManager_hoveredControlIndex = new WeakMap(), _ControlsManager_hoveredControlDistance = new WeakMap(), _ControlsManager_isDraggingControl = new WeakMap(), _ControlsManager_materialIndexArray = new WeakMap(), _ControlsManager_positionArray = new WeakMap(), _ControlsManager_positionIndexArray = new WeakMap();
//# sourceMappingURL=ControlsManager.js.map